import { STEP_IDS } from '@/store';

import {
  BmuCpaYearForm,
  CanCpaProvincesForm,
  CanCpaYearForm,
  DesignationTypesForm,
  Disclaimer,
  Introduction,
  IsDesignatedForm,
  JobDetailsForm,
  NameForm,
  NonDesignatedRegion,
  UsaCpaStatesForm,
  UsaEaNumberForm,
} from './components';

export const StepComponents = {
  [STEP_IDS.introduction]: Introduction,
  [STEP_IDS.isDesignated]: IsDesignatedForm,
  [STEP_IDS.nonDesignatedRegion]: NonDesignatedRegion,
  [STEP_IDS.designationTypes]: DesignationTypesForm,
  [STEP_IDS.disclaimer]: Disclaimer,
  [STEP_IDS.canCpaProvinces]: CanCpaProvincesForm,
  [STEP_IDS.canCpaYear]: CanCpaYearForm,
  [STEP_IDS.usaCpaStates]: UsaCpaStatesForm,
  [STEP_IDS.usaEaNumber]: UsaEaNumberForm,
  [STEP_IDS.bmuCpaYear]: BmuCpaYearForm,
  [STEP_IDS.name]: NameForm,
  [STEP_IDS.b2cJobDetails]: JobDetailsForm,
} as const;
